// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__7s3IbuSH","icon":"SelectionActionButton_icon__9AAnFOwR","text":"SelectionActionButton_text__Obpp+uov"};